import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Only import HelmetProvider – DO NOT import BrowserRouter here
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />                 {/* App.jsx already contains <BrowserRouter> */}
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();